import { render } from "./StarAnimation.vue?vue&type=template&id=b97b5d94&scoped=true"
import script from "./StarAnimation.vue?vue&type=script&lang=js"
export * from "./StarAnimation.vue?vue&type=script&lang=js"

import "./StarAnimation.vue?vue&type=style&index=0&id=b97b5d94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97b5d94"]])

export default __exports__